import { CalendarIcon, RefreshIcon } from "@verde/icons";
import { Button, Tag } from "@verde/ui-core";
import { dayjs, formatDate, formatToCPF } from "@verde/utils";
import React from "react";
import { useCreditProfilePanel } from "./panel";

export interface PanelHeadingProps {
  onRefresh?: () => void;
}

function PanelHeading({ onRefresh }: PanelHeadingProps) {
  const { client, mode, resource, updating, handleUnlock } =
    useCreditProfilePanel();

  if (mode === "anchor") return null;

  return (
    <div className="flex items-center justify-between gap-4 rounded-t border border-neutral-light-2 p-6">
      <div className="grid gap-1">
        <p className="text-xl font-bold">{client?.name}</p>
        <p className="font-medium text-neutral-dark-1">
          {formatToCPF(client?.document_number)}
          {client?.birth_date &&
            ` | ${dayjs().diff(dayjs(client?.birth_date), "year")} anos`}
        </p>
      </div>

      <div className="flex items-center gap-4 rounded bg-neutral-light-1 p-2">
        {resource.authorized === false && (
          <Tag label="Autorização necessária" kind="highlight" />
        )}

        {resource.authorized && !resource.available && (
          <>
            <p className="text-base text-neutral-dark-3">
              Autorização concedida em{" "}
              <span className="font-bold">
                {formatDate(client?.rating?.created_at)}
              </span>
            </p>

            <Button onClick={handleUnlock}>Usar crédito e consultar</Button>
          </>
        )}

        {!!resource.available && !updating && (
          <>
            <p className="flex items-center gap-1 text-base text-neutral-dark-3">
              Consultado em{" "}
              <span className="font-bold">
                {formatDate(client?.rating?.created_at)}
              </span>
              <span className="w-fit rounded-full bg-neutral-light-pure p-1">
                <CalendarIcon width={16} height={16} />
              </span>
            </p>

            {onRefresh && (
              <Button
                className="bg-brand-yellow hover:bg-neutral-dark-3 hover:text-brand-yellow"
                icon={<RefreshIcon />}
                onClick={onRefresh}
              >
                Atualizar
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default React.memo(PanelHeading);
